var map = {
	"./accenture_logo.svg": 1115,
	"./activision_logo.svg": 6037,
	"./amazon_logo.svg": 1191,
	"./apple_logo.svg": 245,
	"./bain_logo.svg": 2418,
	"./bam_logo.svg": 1211,
	"./bcg_logo.svg": 7494,
	"./bloomberg_logo.svg": 9104,
	"./c1_logo.svg": 5029,
	"./citadel_logo.svg": 7638,
	"./ctc_logo.svg": 6786,
	"./datadog_logo.svg": 5943,
	"./deloitte_logo.svg": 4478,
	"./goldmansachs_logo.svg": 2646,
	"./google_logo.svg": 3306,
	"./hrt_logo.svg": 2934,
	"./imc_logo.svg": 8569,
	"./janestreet_logo.svg": 8630,
	"./jpmorganchase_logo.svg": 6746,
	"./mckinsey_logo.svg": 3444,
	"./meta_logo.svg": 9507,
	"./microsoft_logo.svg": 2155,
	"./morganstanley_logo.svg": 952,
	"./netflix_logo.svg": 5646,
	"./optiver_logo.svg": 9037,
	"./palantir_logo.svg": 9988,
	"./paypal_logo.svg": 9302,
	"./ramp_logo.svg": 2224,
	"./robinhood_logo.svg": 2359,
	"./roblox_logo.svg": 2996,
	"./stripe_logo.svg": 7997,
	"./uber_logo.svg": 5668,
	"./virtu_logo.svg": 6571,
	"Assets/Vectors/accenture_logo.svg": 1115,
	"Assets/Vectors/activision_logo.svg": 6037,
	"Assets/Vectors/amazon_logo.svg": 1191,
	"Assets/Vectors/apple_logo.svg": 245,
	"Assets/Vectors/bain_logo.svg": 2418,
	"Assets/Vectors/bam_logo.svg": 1211,
	"Assets/Vectors/bcg_logo.svg": 7494,
	"Assets/Vectors/bloomberg_logo.svg": 9104,
	"Assets/Vectors/c1_logo.svg": 5029,
	"Assets/Vectors/citadel_logo.svg": 7638,
	"Assets/Vectors/ctc_logo.svg": 6786,
	"Assets/Vectors/datadog_logo.svg": 5943,
	"Assets/Vectors/deloitte_logo.svg": 4478,
	"Assets/Vectors/goldmansachs_logo.svg": 2646,
	"Assets/Vectors/google_logo.svg": 3306,
	"Assets/Vectors/hrt_logo.svg": 2934,
	"Assets/Vectors/imc_logo.svg": 8569,
	"Assets/Vectors/janestreet_logo.svg": 8630,
	"Assets/Vectors/jpmorganchase_logo.svg": 6746,
	"Assets/Vectors/mckinsey_logo.svg": 3444,
	"Assets/Vectors/meta_logo.svg": 9507,
	"Assets/Vectors/microsoft_logo.svg": 2155,
	"Assets/Vectors/morganstanley_logo.svg": 952,
	"Assets/Vectors/netflix_logo.svg": 5646,
	"Assets/Vectors/optiver_logo.svg": 9037,
	"Assets/Vectors/palantir_logo.svg": 9988,
	"Assets/Vectors/paypal_logo.svg": 9302,
	"Assets/Vectors/ramp_logo.svg": 2224,
	"Assets/Vectors/robinhood_logo.svg": 2359,
	"Assets/Vectors/roblox_logo.svg": 2996,
	"Assets/Vectors/stripe_logo.svg": 7997,
	"Assets/Vectors/uber_logo.svg": 5668,
	"Assets/Vectors/virtu_logo.svg": 6571
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9277;